/**
 * Mirrors <x-menu-icon icon="brand" :size="24"> (menu-icon.blade.php, which
 * resolves 'brand' -> the 'vlf-award' sprite symbol via MenuIconHelper::MAP —
 * a distinct key from 'award' -> 'vlf-brands', used by the navbar's "Brands"
 * nav item, not by this per-product brand-line icon). The sprite defs are
 * pushed globally by navbar.blade.php's own <x-menu-icon> usage, so every
 * page already has #vlf-award available.
 */
export function buildBrandIconHtml(size = 24): string {
    return `<svg class="vlf-icon menu-icon vlf-icon--${size}" aria-hidden="true"><use href="#vlf-award"></use></svg>`;
}
